import api from "../../../api/axios";

/**
 * D2-E1 — Property reverse party-filtered Deals transport.
 * Read-only; never calls full Deal list/detail endpoints.
 */

export const fetchPropertyDeals = (propertyId, params = {}, { signal } = {}) =>
  api
    .get(`/realty/properties/${propertyId}/deals/`, { params, signal })
    .then((res) => res.data);

export const unwrapPropertyDealsPage = (data) => {
  if (Array.isArray(data)) {
    return {
      results: data,
      count: data.length,
      next: null,
      previous: null,
    };
  }
  if (data && typeof data === "object") {
    return {
      results: Array.isArray(data.results) ? data.results : [],
      count: typeof data.count === "number" ? data.count : 0,
      next: data.next || null,
      previous: data.previous || null,
    };
  }
  return { results: [], count: 0, next: null, previous: null };
};

export const pickCompactPropertyDealFields = (row) => {
  if (!row || typeof row !== "object") return null;
  return {
    id: row.id,
    property_title_snapshot: row.property_title_snapshot,
    status: row.status,
    created_at: row.created_at,
    updated_at: row.updated_at,
  };
};
